import { render, staticRenderFns } from "./nav-dropdown-content.vue?vue&type=template&id=087ba4ab&scoped=true&"
import script from "./nav-dropdown-content.vue?vue&type=script&lang=js&"
export * from "./nav-dropdown-content.vue?vue&type=script&lang=js&"
import style0 from "./nav-dropdown-content.vue?vue&type=style&index=0&id=087ba4ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ba4ab",
  null
  
)

export default component.exports